import React from 'react';
import cx from 'classnames';
import { RichText } from '@vimily/bonjoro-ui-components-v2/RichTextEditor';
import { RichTextViewer } from '@vimily/bonjoro-ui-components-v2/RichTextViewer';
import { UserSimple } from '~/types/models/index';
import { theme } from '@vimily/bonjoro-ui-components-v2';

export interface IntroCard {
  user: UserSimple;
  message: RichText;
  className?: string;
  fontColor?: string;
  fontFamily?: string;
}

export default function IntroCard({
  user,
  message,
  className,
  fontColor = theme.colors.neutral[900],
  fontFamily,
}: IntroCard) {
  return (
    <div
      className={cx(
        'bg-white w-full shadow-md rounded p-5 md:p-8 mb-5',
        className
      )}
    >
      <div className='flex mb-5'>
        <img
          className='rounded w-[50px] h-[50px] mr-5'
          src={user.image}
          alt={user.bio as string | undefined}
        />
        <div style={{color: fontColor}} className='my-auto'>
          <div className='text-base font-bold mb-0.5'>
            {user.first_name} {user.last_name}
          </div>
          {user.bio && <div className='text-sm'>{user.bio}</div>}
        </div>
      </div>
      <RichTextViewer value={message} style={{color: fontColor, fontFamily}} />
    </div>
  );
}
